import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { Stack, IconButton, Box, Tooltip, Collapse } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import GoodsReceiveCard from "../../../Components/Card/TransactionCards/GoodsReceive/GoodsReceiveCard";
import GoodsReceiveTable from "../../../Components/Card/TransactionCards/GoodsReceive/GoodsReceiveTable";

const GoodsReceive = () => {
  const [editData, setEditData] = useState({});
  const [isChanged, setIsChanged] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleEdit = (data) => {
    setEditData(data[0]);
    setIsFormOpen(true);
  };

  const handleToggleForm = () => {
    setIsFormOpen(!isFormOpen);
    if (isFormOpen) {
      setEditData({});
    }
  };

  return (
    <>
      <Container sx={{ pt: { xs: 14, sm: 6 } }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <h3 style={{ margin: 0, color: "#1D5FB1", fontFamily: "Helvetica, Arial, sans-serif", fontSize: "24px", textAlign: "center", flex: 1 }}>Goods Receive Note</h3>
          <Tooltip title={isFormOpen ? "Close Form" : "Add New Goods Receive"}>
            <IconButton
              onClick={handleToggleForm}
              sx={{
                backgroundColor: isFormOpen ? "#f44336" : "#4caf50",
                color: "white",
                padding: "12px",
                borderRadius: "4px",
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: isFormOpen ? "#da190b" : "#45a049",
                  transform: "scale(1.1)",
                },
                boxShadow: 2,
                fontSize: "28px",
                display: "inline-flex",
                ml: 2,
              }}
            >
              {isFormOpen ? <CloseIcon key="close" /> : <AddIcon key="add" />}
            </IconButton>
          </Tooltip>
        </Box>

        <Collapse in={isFormOpen} timeout="auto">
          <Box sx={{ mb: 3 }}>
            <Box
              sx={{
                width: "100%",
                backgroundColor: "#e3f3fc",
                padding: { xs: 0, sm: 3 },
                borderRadius: "10px",
                border: "none",
                margin: "10px",
              }}
            >
              <GoodsReceiveCard
                editData={editData}
                setEditData={setEditData}
                isChanged={isChanged}
                setIsChanged={setIsChanged}
                setIsFormOpen={setIsFormOpen}
              />
            </Box>
          </Box>
        </Collapse>
                </Container>
                <Stack direction="column" justifyContent="flex-start" width="100%" my={2}>
                  <GoodsReceiveTable handleEditData={handleEdit} isChanged={isChanged} setIsChanged={setIsChanged} />
                </Stack>
    </>
  );
};

export default GoodsReceive;
